import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { RedirectService } from '../services/redirect.service';
import { LoggingService } from '../services/logging.service';
import { OiamService } from '../services/apiservices/oiam.service';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';

const REDIRECT_PARAM = 'redirect' as const;

export const redirectGuard: CanActivateFn = (_route, state) => {
    const oiamService     = inject(OiamService);
    const redirectService = inject(RedirectService);
    const loggingService  = inject(LoggingService);

    const activation = environment.oiam.enabled
        ? oiamService.canActivateRoute(state.url)
        : true;

    const activation$: Observable<boolean | string> =
        typeof activation === 'boolean' ? of(activation) : activation;

    return activation$.pipe(
        tap(() => handleRedirect(state, redirectService, loggingService)),
        map(() => true)
    );
};

function handleRedirect(
    state: RouterStateSnapshot,
    redirectService: RedirectService,
    loggingService: LoggingService
): void {
    const redirectUrl = state.root.queryParamMap.get(REDIRECT_PARAM);
    if (!redirectUrl) return;


    if (isValidRedirect(redirectUrl)) {
        redirectService.set(redirectUrl);
    } else {
        loggingService.warn('Redirect-Url invalid: ' + redirectUrl);
        redirectService.set(null);
    }
}

function isValidRedirect(url: string): boolean {
    try {
        const target = new URL(url);
        if (target.protocol !== 'https:') return false;

        // ermittelt den domainpart der url (ohne subdomains)
        const getDomain = (host: string): string => {
            const match = /([^.]+\.[^.]+)$/.exec(host);
            return match?.[1]?.toLowerCase() ?? host.toLowerCase();
        };

        const targetDomain  = getDomain(target.hostname);
        const currentDomain = getDomain(globalThis.location.hostname);

        return targetDomain === currentDomain;
    } catch {
        return false;
    }
}